import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

type Tone = 'neutral' | 'ink' | 'soft' | 'success';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  leadingDot?: boolean;
  children: ReactNode;
}

const toneClasses: Record<Tone, string> = {
  neutral: 'bg-canvas text-ink border-line',
  soft: 'bg-rail text-ink-muted border-transparent',
  ink: 'bg-canvas text-ink border-ink',
  success: 'bg-canvas text-emerald-700 border-emerald-300',
};

const dotClasses: Record<Tone, string> = {
  neutral: 'bg-ink-faint',
  soft: 'bg-ink-faint',
  ink: 'bg-ink',
  success: 'bg-emerald-500',
};

export function Badge({ tone = 'neutral', leadingDot, className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wide',
        toneClasses[tone],
        className,
      )}
      {...props}
    >
      {leadingDot ? <span className={cn('h-1.5 w-1.5 rounded-full', dotClasses[tone])} /> : null}
      {children}
    </span>
  );
}
